export const NAV_LINKS = [
  'overview',
  'portfolio',
  'documents'
]

export default {
  NAV_LINKS
}



// WEBPACK FOOTER //
// ./src/utils/Client/navLinks.js